import BlockSettings from "app/blocks/models/block-settings.interface";

const getWrapperClasses = (settings: BlockSettings): string[] => {
    const classes = [];

    if (settings?.spacingTop) {
        classes.push(`spacing-top--${settings.spacingTop}`);
    }
    else {
        classes.push("spacing-top--Medium");
    }

    if (settings?.spacingBottom) {
        classes.push(`spacing-bottom--${settings.spacingBottom}`);
    }
    else {
        classes.push("spacing-bottom--Medium");
    }

    if (settings?.showBorderTop && settings.showBorderBottom) {
        classes.push("border-both");
    }
    else if (settings?.showBorderTop) {
        classes.push("border-top");
    }
    else if (settings?.showBorderBottom) {
        classes.push("border-bottom");
    }

    return classes;
};

export default getWrapperClasses;